<!--
* UIID: UI-CAAS-COM-112
* UI Name: SMTP
* Modify Date: 2020/06/15
-->
<template>
  <v-card flat>
    <v-card-text>
      <v-form ref="form" lazy-validation class="px-4" style="overflow-y: scroll;height: 580px;">
        <!-- First Row -->
        <v-row>
          <v-col cols="12" md="4" class="mt-6">
            <font class="text-base font-bold leading-snug textcolor5--text">
              {{ $t('lbl.communications.smtp') }}
            </font>
            <v-text-field
              v-model="formData.name"
              :rules="
                formData.name && formData.name.length > 50
                  ? ['Max 50 characters']
                  : [validationUtils.required]
              "
              :error-messages="formError.name.message"
              placeholder="Enter the name"
              ref="name"
              :autofocus="true"
              solo
              :disabled="!$auth.manage"
              class="mt-5"
            ></v-text-field>
          </v-col>
          <!-- // 2021.8.30 203728 SPKA-201 remove partner from communication -->
          <!-- <v-col cols="12" md="4">
            <v-select
              v-model="formData.partner"
              :items="partners"
              :placeholder="$t('lbl.common.conditionSearch.selectPartner')"
              solo
              :menu-props="{ offsetY: true, }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col> -->
          <!-- 203665 2021/03/03
            SPKA-44 Remove Direction on screen Communication 
          -->
          <!-- <v-col cols="12" md="4">
            <v-select
                v-model="formData.direction"
              :items="inouts"
              :placeholder="$t('lbl.common.conditionSearch.selectDirection')"
              solo
              :menu-props="{ offsetY: true, }"
              :disabled="!$auth.manage"
            ></v-select>
          </v-col> -->
        </v-row>
        <!-- 2 Row 54px-->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Server address</v-label>
            <v-text-field
              v-model="formData.host"
              :rules="[validationUtils.required, validationUtils.max(50)]"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-row>
              <v-col cols="12" md="8" class="pr-0">
                <v-label>Security</v-label>
                <v-select
                  v-model="formData.security"
                  :items="securities"
                  solo
                  :menu-props="{ offsetY: true }"
                  :disabled="!$auth.manage"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Port</v-label>
                <v-text-field
                  v-model="formData.port"
                  type="number"
                  :rules="[validationUtils.required, validationUtils.max(5)]"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row><v-col cols="12" md="12" class="h-2"></v-col></v-row>
        <!--3 Row 40px-->
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>User ID</v-label>
            <v-text-field
              v-model="formData.userid"
              :rules="[validationUtils.required, validationUtils.max(200)]"
              solo
              :disabled="!$auth.manage"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Password</v-label>
            <v-text-field
              v-model="formData.password"
              :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
              :type="formData.showpassword ? 'text' : 'password'"
              @click:append="formData.showpassword = !formData.showpassword"
              :rules="[validationUtils.required, validationUtils.max(50)]"
              solo
              :disabled="!$auth.manage"
              autocomplete="off"
              @focus="handlePasswordType"
              @blur="handlePasswordType"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="px-4">
            <v-label>{{ $t('lbl.communications.senderEmail') }}</v-label>
            <v-text-field
              v-model="formData.senderEmail"
              :rules="
                formData.senderEmail
                  ? [validationUtils.multiEmailRules(10), validationUtils.max(100)]
                  : []
              "
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="px-4">
            <v-label
              ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
              >{{ $t('lbl.communications.recepientEmail') }}</v-label
            >
            <v-text-field
              v-model="formData.email"
              :rules="[
                validationUtils.required,
                validationUtils.multiEmailRules(10),
                validationUtils.max(500),
              ]"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- /**
         * 2021.10.01 203737 SPKA-225 Add "Email Subject" in Add/Modify Communication popup for SMTP
         */ -->
        <v-row>
          <v-col cols="12" md="12">
            <v-label>Email Subject</v-label>
            <v-text-field
              v-model="formData.emailSubject"
              :rules="
                formData.emailSubject && formData.emailSubject.length > 300
                  ? ['Max 300 characters']
                  : []
              "
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- /**
         * 2022.12.13 213979 SPKA-597 Add "Body" in Add/Modify Communication popup for SMTP
         */ -->
        <v-row>
          <v-col cols="12" md="6">
            <v-label>Body</v-label>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end align-center">
            <v-label>Attach (File)</v-label>
            <v-checkbox
              v-model="formData.attach"
              color="#497DDE"
              dense
              hide-details
              class="mt-0 ml-2 pt-0"
              true-value="Y"
              false-value="N"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" md="12">
            <v-textarea
              v-model="formData.body"
              solo
              height="60"
              :rules="formData.body && formData.body.length > 300 ? ['Max 300 characters'] : []"
              :disabled="!$auth.manage"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" class="pr-0">
            <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
            <v-text-field
              v-model="formData.maxRetry"
              type="number"
              solo
              :disabled="!$auth.manage"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { getEditData } from '@/vue-caas/utils/process';

export default {
  props: {
    item: {
      default: Object,
    },
    // 2021.8.30 203728 SPKA-201 remove partner from communication
    // prnrList: {
    //   type: Array,
    // },
  },

  data: () => {
    return {
      securities: [
        { text: 'NONE', value: 'NONE' },
        { text: 'SSL', value: 'SSL' },
        { text: 'TLS', value: 'TLS' },
      ],
      // 2021.8.30 203728 SPKA-201 remove partner from communication
      // partners: [
      //   {value: 'INT', text: 'INTTRA'},
      //   {value: 'ONE', text: 'ONE'},
      //   {value: 'SO', text: 'SmartLink Platform'},
      //   {value: 'PORTE', text: 'PORTEVER'},
      //   {value: 'FL', text: 'Faircon Line'},
      //   {value: 'ULS', text: 'ULS'},
      //   {value: 'WooW', text: 'WooWon'},
      //   {value: 'IMPEX', text: 'IMPEX'}
      // ],
      inouts: [
        { value: 'I', text: 'INBOUND' },
        { value: 'O', text: 'OUTBOUND' },
      ],
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
    };
  },

  created() {
    this.formData = Object.assign({}, this.getInitData(), this.item);
    if (this.formData.password) this.formData.showpassword = false;
    this.loadFormData = Object.assign({}, this.getInitData(), this.item);
    if (this.loadFormData.password) this.loadFormData.showpassword = false;
    if (this.formData.email == null) {
      this.formData.email = '';
    }
    if (this.formData.senderEmail == null) {
      this.formData.senderEmail = '';
    }
    // 2021.8.30 203728 SPKA-201 remove partner from communication
    // this.partners = this.prnrList;
  },

  watch: {
    item() {
      this.resetFormData();
      this.setFocus();
    },
  },

  methods: {
    handlePasswordType(event) {
      const { srcElement, type } = event;
      const { value } = srcElement;
      if (type === 'focus' && !value) {
        this.formData.showpassword = false;
      }
      if (type === 'blur' && !value) {
        this.formData.showpassword = true;
      }
    },
    async save() {
      /**
       * 2021.08.23 203737 SPKA-200 issue 126 Modify Add/Modify communication popup. (SMTP)
       * Set path using email
       */
      // 2022.01.24 213960 SPKA-390 Fix the email address in SMTP communication
      // this.formData.path = this.formData.email;
      if (this.formData.action == 'edit') {
        /* 
          2021/01/15 203665 workflow issue 21  send only edit Data to JSON
        */
        let editedData = getEditData(this.formData, this.loadFormData);
        editedData.id = this.formData.id;
        if (editedData.name === undefined) {
          editedData.name = this.formData.name;
        }
        editedData.protocol = this.formData.type;
        await this.$store.dispatch('editComm', this.formData);
        await this.sendActivate(this.formData.id, 'COM', editedData);
      } else {
        this.formData.type = 'SMTP';
        await this.$store.dispatch('insertComm', this.formData);
      }
      this.resetFormData();
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },

    getInitData() {
      return {
        name: '',
        partner: '',
        direction: '',
        host: '',
        security: '',
        port: '',
        userid: '',
        password: '',
        showpassword: true,
        email: '',
        type: 'SMTP',
        body: 'Please check attached file',
        attach: false,
      };
    },
    // hasEditForm() {
    //   const defaultForm = this.getInitData();
    //   for (const prop in defaultForm) {
    //     if (prop != 'showpassword' && prop != 'type') {
    //       if (this.formData[prop].trim() != '') {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
    resetFormData() {
      if (this.item.type == 'SMTP') {
        this.formData = Object.assign({}, this.getInitData(), this.item);
        this.$refs.form.resetValidation();
      }
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
  },
};
</script>

<style></style>
